const envJson = require('./env.json')


exports.configuration = {

    environment: envJson.VUE_APP_NODE_ENV,

    url: {

        baseUrl: envJson.VUE_APP_BASE_URL,
        server: envJson.VUE_APP_CLEANFOX_API_ROOT
    },

    front: {
        minimalAge: envJson.VUE_APP_MINIMAL_AGE,
        abTestingMaxDuration: envJson.VUE_APP_AB_TIMEOUT || 2000
    },

    email: {
        contact: 'support@cleanfox.io'
    },

    size: {
        tablet: 568,
        desktop: 800
    },

    tracking: {
        gtagId: envJson.VUE_APP_GTAG_ID,
        optimizeId: envJson.VUE_APP_OPTIMIZE_ID,
        amplitudeKey: envJson.VUE_APP_AMPLITUDE_KEY,
        smartBannerWebToken: envJson.VUE_APP_SMARTBANNER_WEB_TOKEN,
        adjustAppToken: envJson.VUE_APP_ADJUST_APP_TOKEN
    },

    languages: {
        all: [
            'ar-sa',
            'da-dk',
            // 'de-at',
            'de-de',
            'en-gb',
            'es-es',
            'fr-fr',
            'hi-in',
            'it-it',
            'ja-jp',
            'nl-be',
            'nl-nl',
            'pl-pl',
            'pt-pt',
            'sv-se'
        ],
        backwardLanguage: {
            'ar': 'ar-sa',
            'da': 'da-dk',
            'de': 'de-de',
            'en': 'en-gb',
            'es': 'es-es',
            'fr': 'fr-fr',
            'hi': 'hi-in',
            'it': 'it-it',
            'ja': 'ja-jp',
            'nl': 'nl-nl',
            'pl': 'pl-pl',
            'pt': 'pt-pt',
            'sv': 'sv-se'
        },
        lokaliseFilesName: {
            'ar-sa': 'ar_SA.json',
            'da-dk': 'da_DK.json',
            // 'de-at': 'de_AT.json',
            'de-de': 'de.json',
            'en-gb': 'en.json',
            'es-es': 'es.json',
            'fr-fr': 'fr.json',
            'hi-in': 'hi_IN.json',
            'it-it': 'it.json',
            'ja-jp': 'ja_JP.json',
            'nl-be': 'nl_BE.json',
            'nl-nl': 'nl_NL.json',
            'pl-pl': 'pl.json',
            'pt-pt': 'pt_PT.json',
            'sv-se': 'sv.json'
        },
        byName: {
            english: 'en',
            french: 'fr',
            german: 'de',
            arabe: 'ar'
        }
    },

    defaultLanguage: 'en-gb',

    defaultMetaLanguage: 'default',

    sharingCardsPositionDefault: [20, 60],
    
    firebaseConfig: {
        apiKey: envJson.VUE_APP_FIREBASE_API_KEY,
        authDomain: envJson.VUE_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: envJson.VUE_APP_FIREBASE_DATABASE_URL,
        projectId: envJson.VUE_APP_FIREBASE_PROJECT_ID,
        storageBucket: envJson.VUE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: envJson.VUE_APP_FIREBASE_MESSAGIN_SENDER_ID,
        appId: envJson.VUE_APP_FIREBASE_APP_ID,
        measurementId: envJson.VUE_APP_FIREBASE_MEASURMENT_ID,
        cloudMessagingCertificat: envJson.VUE_APP_CERTIFICATS_WEB_PUSH
    },

    oauth: {
        microsoft: {
            clientId: envJson.VUE_APP_MICROSOFT_CLIENT_ID,
            authority: envJson.VUE_APP_MICROSOFT_AUTHORITY || 'https://login.microsoftonline.com/common',
            redirectUri: envJson.VUE_APP_MICROSOFT_REDIRECT_URI,
            scope: envJson.VUE_APP_MICROSOFT_SCOPE || 'offline_access https://outlook.office.com/IMAP.AccessAsUser.All User.Read'
        }
    },

    indexedDb: {
        name: 'cleanfox',
        version: 1
    }
}
